// The two logs: events (what the portal publishes and receives, SPEC §10) and the audit log (who did what).
// Neither ever holds personal data: lead codes only, and no suppression reason in an outbound event.
import { z } from 'zod'
import { Id, IsoDateTime } from './common'

export const EventDirection = z.enum(['in', 'out'])
export type EventDirection = z.infer<typeof EventDirection>

export const EventEntry = z.object({
  id: Id,
  at: IsoDateTime,
  direction: EventDirection,
  type: z.string().describe('e.g. campaign.messaged, partner.lead.accepted'),
  summary: z.string(),
})
export type EventEntry = z.infer<typeof EventEntry>

export const AuditEntry = z.object({
  id: Id,
  at: IsoDateTime,
  user_name: z.string().describe('"system" for what the run engine did by itself'),
  action: z.string().describe('e.g. campaign.approve, suppress.remove'),
  target: z.string(),
  detail: z.string(),
})
export type AuditEntry = z.infer<typeof AuditEntry>

export interface LogApi {
  /** newest first, the last 500 (without the webhooks) */
  listEvents(): Promise<EventEntry[]>
  /** CW4: newest first, the last 500 webhooks (type webhook.<kind>): what came in, what it matched, the result.
   *  WH1: only one campaign's when campaignId is given */
  listWebhooks(campaignId?: string): Promise<EventEntry[]>
  /** newest first, the last 400 */
  listAudit(): Promise<AuditEntry[]>
}
